import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScriptsCallback } from '../../../helpers/Utils';

export function PricingCostModelPage(): React.ReactElement {
  const currentSecurity = useSecurity('Pricing', 'CostModel');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(["Areas/Pricing/Scripts/Resources/en/res.CostModel.en.js",
        "Areas/Pricing/Scripts/Resources/en/Types.en.js",
        "Areas/Pricing/Scripts/Enums.js",
        "Areas/Pricing/Scripts/CostModel/Index.js"], "initPricingCostModel", {});
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
